import { AsyncPipe } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCurrentUser } from '../store/selectors';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-user-topbar-section',
  templateUrl: './user-topbar-section.component.html',
  styleUrls: ['./user-topbar-section.component.scss'],
  imports: [UserAvatarComponent, AsyncPipe],
})
export class UserTopbarSectionComponent {
  private _store = inject(Store);

  readonly avatarClicked = output<void>();

  currentUser$ = this._store.select(getCurrentUser);

  constructor() {}
}
